import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Search } from '@bn/api-interfaces';
import { AbstractApiService } from '@bn/shared/entities/abstracts/abstract-api.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends AbstractApiService {
  public constructor() {
    super();
    this.apiUrl = `${this.envConfig.apiUrl}/search`;
  }

  public getSearchResults(searchTerm: string): Observable<Search> {
    return this.httpClient.get<Search>(`${this.apiUrl}?search=${searchTerm}`);
  }
}
